/**
 * Spotlight Content — Exo Entertainment
 * Hero carousel slides with gradient placeholders
 */

export const spotlightContent = [
  {
    name: "Private VIP Entertainment",
    heroBanner: "/images/hero-1.jpg",
    heroBannerMobile: "/images/hero-1.jpg",
    title: "Calgary's Premier Private Entertainment",
    subtitle: "VIP dance shows, bachelor parties & curated experiences — available 24/7 in Calgary, AB",
    heroLink: {
      type: "external",
      url: "/book",
      buttonText: "Book Now",
    },
  },
  {
    name: "Meet Our Performers",
    heroBanner: "/images/hero-2.jpg",
    heroBannerMobile: "/images/hero-2.jpg",
    title: "Calgary's Finest Entertainers",
    subtitle: "Persona-driven performers delivering unforgettable private shows across Calgary",
    heroLink: {
      type: "external",
      url: "/entertainers",
      buttonText: "Meet the Cast",
    },
  },
  {
    name: "Bachelor Parties",
    heroBanner: "/images/hero-3.jpg",
    heroBannerMobile: "/images/hero-3.jpg",
    title: "Celebrate in Calgary",
    subtitle: "Bachelor parties, private events & VIP experiences — outcall anywhere in Calgary",
    heroLink: {
      type: "external",
      url: "/services",
      buttonText: "View Packages",
    },
  },
];
